export default __webpack_public_path__ + "static/media/squareup-logo.0c0fe4f1.png";